const badges = [
  { 
    title: 't(Platform)', 
    weight: 10, 
    access: {
      rights: { $allOf: ['platform:access_app'] }
    },
    svg: 'settings', 
    route: '/admin/platform', 
    visible: ['desktop','tablet'],
    tooltip: 't(Platform)' 
  }
]

export default badges
